import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import AddProduct from '../components/admin/AddProduct';
import ProductList from '../components/admin/ProductList';
import AdminStats from '../components/admin/AdminStats';
import OrdersList from '../components/admin/OrdersList';

export default function AdminDashboard() {
  const { currentUser, userRole, loading } = useAuth();
  const [activeTab, setActiveTab] = useState('dashboard');

  useEffect(() => {
    console.log('[AdminDashboard] auth state', {
      loading,
      uid: currentUser?.uid,
      email: currentUser?.email,
      userRole,
    });
  }, [loading, currentUser, userRole]);

  // Redirect if not admin
  if (loading) return <div className="loading">Loading...</div>;
  if (!currentUser || userRole !== 'admin') {
    return (
      <div className="page-container">
        <header className="page-header">
          <h1>Admin Dashboard</h1>
          <p style={{ margin: 0 }}>
            Signed in as: <b>{currentUser?.email || 'Not signed in'}</b> — role:{' '}
            <b>{userRole || 'none'}</b>
          </p>
        </header>
        <main className="page-content">
          <div className="unauthorized-container">
            <h2>403 - Unauthorized</h2>
            <p>
              Your account is not marked as <b>admin</b>, so admin tools are hidden.
            </p>
            <p style={{ marginTop: 12 }}>
              Fix: In Firestore, open <code>users/{currentUser?.uid || 'UID'}</code> and set{' '}
              <code>role</code> to <code>"admin"</code>, then log out + log in.
            </p>
          </div>
        </main>
      </div>
    );
  }

  return (
    <div className="page-container">
      <header className="page-header">
        <h1>Admin Dashboard</h1>
        <p>Welcome back, {currentUser.email}</p>
      </header>
      
      <main className="page-content">
        {/* Admin Navigation Tabs */}
        <div className="admin-tabs">
          <button 
            className={`tab-button ${activeTab === 'dashboard' ? 'active' : ''}`}
            onClick={() => setActiveTab('dashboard')}
          >
            📊 Dashboard
          </button>
          <button 
            className={`tab-button ${activeTab === 'products' ? 'active' : ''}`}
            onClick={() => setActiveTab('products')}
          >
            📦 Products
          </button>
          <button 
            className={`tab-button ${activeTab === 'add-product' ? 'active' : ''}`}
            onClick={() => setActiveTab('add-product')}
          >
            ➕ Add Product
          </button>
          <button 
            className={`tab-button ${activeTab === 'orders' ? 'active' : ''}`}
            onClick={() => setActiveTab('orders')}
          >
            🧾 Orders
          </button>
        </div>

        {/* Tab Content */}
        <div className="tab-content">
          {activeTab === 'dashboard' && <AdminStats />}
          {activeTab === 'products' && <ProductList />}
          {activeTab === 'add-product' && <AddProduct />}
          {activeTab === 'orders' && <OrdersList />}
        </div>
      </main>
    </div>
  );
}
